import React, { FC, useCallback, useEffect } from "react";
import { get } from "lodash";
import styled from "styled-components";

import { capitalize } from "@formant/core/common/capitalize";
import { defined } from "@formant/core/common/defined";
import { formatCamelCase } from "@formant/core/common/formatCamelCase";

import { Switch } from "../common/Switch";
import { evaluateExpression } from "./evaluateExpression";
import { Label } from "./Label";
import { ListButton } from "./ListButton";
import { IInputProps, IJsonBooleanSchema } from "./types";
import { updatePath } from "./updatePath";

export const BooleanInput: FC<IInputProps<IJsonBooleanSchema>> = props => {
    const { params, schema, setParams, path } = props;

    useEffect(() => {
        const currentValue = get(params, path);
        if (currentValue === undefined && schema.default !== undefined) {
            setParams(prev => updatePath(prev, path, schema.default));
        }
    }, []);

    const handleChange = useCallback(
        (changed: boolean) => {
            setParams(prev => updatePath(prev, path, changed));
        },
        [path, setParams],
    );

    if (!evaluateExpression(params, path, schema["$formant.visible.when"])) {
        return null;
    }

    return (
        <>
            <Label
                value={capitalize(formatCamelCase(defined(schema.title)))}
                description={schema.description}
            />
            <ListButton>
                <StyledSwitch
                    state={get(params, path) ?? false}
                    onChange={handleChange}
                    label={(get(params, path) ?? false) ? "On" : "Off"}
                />
            </ListButton>
        </>
    );
};

const StyledSwitch = styled(Switch)`
    width: 100%;
    margin: 1rem 0;
    * > {
        background-color: none;
    }
`;
